import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Carousel from 'react-elastic-carousel';

import SrBox from 'client/components/SrBox';
import SrFlex from 'client/components/SrFlex';
import SrText from 'client/components/SrText';
import SrIcon from 'client/components/SrIcon';
import ButtonDeprecated, {
  BUTTON_THEME_YELLOW_GREYCLIFF,
} from 'client/components/ButtonDeprecated';
import SrMarkdown, {
  SR_MARKDOWN_THEME_GREYCLIFF,
} from 'client/components/SrMarkdown';
import SrContactUsButton from 'client/components/SrContactUsButton';
import SrNavbarContainer from 'client/components/SrNavbarContainer';
import SrProgressBarPercent from 'client/components/SrProgressBarPercent/SrProgressBarPercent';

const SelfTourMultiFamilyPageLayout = ({
  percentage,
  stepNumber,
  id,
  apartmentName,
  stepName,
  code,
  description,
  buttonCTAText,
  buttonCTATheme,
  photoUrls,
  buttonDOM,
  mediaRender,
  contentRender,
  onClickExit,
  onClickGoBack,
  onClickButtonCTA,
}) => {
  return (
    <div className={classnames('SelfTourMultiFamilyPageLayout', id)}>
      <SrNavbarContainer>
        <div className='SelfTourMultiFamilyPageLayoutNavbar'>
          <div>
            <div
              onClick={onClickGoBack || onClickExit}
              className='buttonRounded'
            >
              <SrIcon
                className={onClickGoBack ? 'arrow-head-back-dark' : 'x-close-dark'}
              />
            </div>
          </div>
          <SrBox display='contents' textAlign='center'>
            <SrText
              font='greycliff'
              weight='800'
              className='apartmentName'
            >
              Self Tour: {apartmentName}
            </SrText>
          </SrBox>
          <div>
            <SrContactUsButton />
          </div>
        </div>
        <SrProgressBarPercent percent={percentage} />
      </SrNavbarContainer>
      <div className='SelfTourMultiFamilyPageLayoutMain'>
        <SrBox className='mediaContainer'>
          {photoUrls.length > 0 && (
            <Carousel
              className='carousel'
              showArrows={false}
              pagination={photoUrls.length > 1}
              transitionMs={100}
            >
              {photoUrls.map((photoUrl) => {
                return (
                  <div key={photoUrl} className='photoContainer'>
                    <div
                      style={{ backgroundImage: `url("${photoUrl}")` }}
                      className='photoUrl'
                    />
                  </div>
                );
              })}
            </Carousel>
          )}
          {mediaRender ? mediaRender() : null}
        </SrBox>
        <SrBox className='contentContainer'>
          <SrFlex justify='center'>
            {stepNumber && (
              <SrFlex className='yellowIcon' justify='center' marginRight='8px'>
                <SrText font='greycliff' weight='800' size='13' lineHeight='22px'>{stepNumber}</SrText>
              </SrFlex>
            )}
            <SrText font='greycliff' weight='800' lineHeight='23px'>{stepName}</SrText>
          </SrFlex>
          <SrFlex direction='col' justify='center' marginTop='15px' marginBottom='20px'>
            {contentRender ? contentRender() : null}
            {code && (
              <div className='codeBox'>
                <SrText display='block' font='greycliff' weight='800' size='30' paddingTop='15px'>
                  {code}
                </SrText>
              </div>
            )}
            {description && (
              <SrBox marginTop={code ? '15px' : 0}>
                <SrMarkdown
                  source={description}
                  theme={SR_MARKDOWN_THEME_GREYCLIFF}
                />
              </SrBox>
            )}
          </SrFlex>
          {buttonCTAText && (
            <ButtonDeprecated theme={buttonCTATheme} onClick={onClickButtonCTA} className='buttonCTA'>
              {buttonCTAText}
            </ButtonDeprecated>
          )}
          {buttonDOM}
        </SrBox>
      </div>
    </div>
  );
};

SelfTourMultiFamilyPageLayout.propTypes = {
  percentage: PropTypes.number.isRequired,
  stepNumber: PropTypes.number,
  id: PropTypes.string.isRequired,
  apartmentName: PropTypes.string.isRequired,
  stepName: PropTypes.string.isRequired,
  code: PropTypes.string,
  description: PropTypes.string,
  buttonCTAText: PropTypes.string,
  buttonCTATheme: PropTypes.string,
  photoUrls: PropTypes.array,
  buttonDOM: PropTypes.node,
  mediaRender: PropTypes.func,
  contentRender: PropTypes.func,
  onClickExit: PropTypes.func,
  onClickGoBack: PropTypes.func,
  onClickButtonCTA: PropTypes.func,
};

SelfTourMultiFamilyPageLayout.defaultProps = {
  buttonCTATheme: BUTTON_THEME_YELLOW_GREYCLIFF,
  photoUrls: [],
};

SelfTourMultiFamilyPageLayout.displayName = 'SelfTourMultiFamilyPageLayout';

export default SelfTourMultiFamilyPageLayout;
